
import React, { useState, useEffect, useCallback } from 'react'
import { Contacts } from '../model'
import { DialogConfirm } from '../../modals/confirm/DialogConfirm'
// import { toast } from 'react-toastify'
import iconRemove from '../../modals/confirm/iconRemove.svg'

export const SeccionContactos = ({ form, openMas }) => {

    const [relacionados, setRelacionados] = useState([])
    const [openConfirm, setOpenConfirm] = useState(false)
    const [obj, setObj] = useState({})

    const getRelacionados = useCallback(async () => {
        setRelacionados(await Contacts.getRelacionados(form.id))
    }, [form.id])

    // const handleChangeCheck = ({ target }) => {
    //     console.log(target.checked)
    // }

    const handleRemove = (id) => {
        setObj({
            title: "Confirmar quitar relación",
            question: '¿Estás seguro de quitar relación?',
            icon: iconRemove,
            answer: async () => {
                if (await Contacts.deleteRelacion(id)) {
                    setRelacionados(relacionados.filter(r => parseInt(r.id) !== parseInt(id)))
                }
                setOpenConfirm(false)
            },
        })
        setOpenConfirm(true)
    }

    useEffect(() => {
        getRelacionados()
    }, [getRelacionados])

    return (
        <div style={{ marginTop: '10px' }}>

            {openConfirm &&
                <DialogConfirm
                    open={openConfirm}
                    setOpen={setOpenConfirm}
                    obj={obj}
                />
            }

            <div className='table-responsive'>

                {relacionados?.length > 0 ?
                    <table className="table p-tabla-relacionados">
                        <thead>
                            <tr>
                                <th scope="col">Nombre</th>
                                <th scope="col">Teléfono</th>
                                <th scope="col">Email</th>
                                {/* <th scope="col">Cargo</th> */}
                                <th scope="col">Principal</th>
                                <th scope="col"></th>
                            </tr>
                        </thead>
                        <tbody>
                            {relacionados?.map(it => (
                                <tr key={it.id}>
                                    <th scope="row" className="text-start" style={{ textTransform: 'capitalize' }}>
                                        {it.nombre}
                                    </th>
                                    <td style={{ fontSize: '12px' }}>{it.fono}</td>
                                    <td>{it.email}</td>
                                    {/* <td style={{ textTransform: 'capitalize' }}>{it.cargo}</td> */}
                                    <td>
                                        <input
                                            type="checkbox"
                                            name="" id=""
                                            checked={it.por_defecto}
                                        // onChange={handleChangeCheck}
                                        />
                                    </td>
                                    <td>
                                        <div className='d-flex justify-content-between'>
                                            {/* <i className="bi bi-pencil me-2 p-icon-rela"></i> */}
                                            <i className="bi bi-trash ms-1 p-icon-rela" onClick={() => handleRemove(it.id)}></i>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    :
                    <div style={{ fontSize: '14px', textAlign: 'center' }}>No hay contactos relacionados</div>
                }


            </div>

        </div >
    )
}